var locales = require('./locales.json')
var template = require('./index.html')
var t = require('../translate')
var config = require('app-config');
var RuneSetOrder = require('../runes-set-order')

module.exports = {
  data: data,
  compiled: function() {
  },
  template: template,
  components: {
    'app-header': { template: require('./header.html'), components: {'app-logo': require('../logo')} },
    'app-footer': require('../footer'),
    'app-runes-set-order': RuneSetOrder,
    'app-logo': require('../logo'),
    'app-video-modal': require('./../runeset-view/video-modal.js')
  },
  methods: {
    t: function(v) {
      return t(locales, v);
    }
  },
  computed: {
    url1: function() { return this.home_url+"/die-halle-der-runen-karten";}
  }
}

function data () {
  return {
    home_url: config.home_url,
    desc: require('../home-view/hallofrunes_desc.html'),    
    country_items: [
      {text: 'Schweiz', value: 'ch'},
      {text: 'Lichtenstein', value: 'li'}
    ]
  }
}


// WEBPACK FOOTER //
// ./lib/runeset-shop-view/index.js